// 加权随机抽取（EP-005-S1）。
// weightedPick：按 weights 归一化概率抽取 items 中一项。weights 与 items 等长；总和需 > 0，
// 否则回退等权（防御配置错误，与 GDD 01 D2/D3 一致）。
export function weightedPick<T>(items: readonly T[], weights: readonly number[], rng: () => number): T {
  const n = items.length;
  if (n === 0) throw new Error('weightedPick: items 为空');
  if (weights.length !== n) throw new Error('weightedPick: items 与 weights 长度不一致');

  let total = 0;
  for (const w of weights) total += w;
  if (!Number.isFinite(total) || total <= 0) {
    // 防御：权重和非法 → 等权
    total = n;
    const r = rng() * n;
    const idx = Math.min(n - 1, Math.floor(r));
    return items[idx] as T;
  }

  const r = rng() * total;
  let acc = 0;
  for (let i = 0; i < n; i++) {
    acc += weights[i] as number;
    if (r < acc) return items[i] as T;
  }
  return items[n - 1] as T;
}
